import React from "react";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";
import RightToWorkChecksPage from "./RightToWorkChecksPage";

interface RightToWorkChecksPageContainerProps extends RouteProps, withValidUserRoleProps {}

const RightToWorkChecksPageContainer = (props: RightToWorkChecksPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    let filterById = "";
    if (props.location && props.location.search) {
        const searchparam = new URLSearchParams(props.location.search.toLowerCase());
        const filterByIdFromURL = searchparam.get("filterby");
        filterById = filterByIdFromURL ? filterByIdFromURL : "";
    }

    return <RightToWorkChecksPage title={getTitle()} category={getType()} queryId={filterById} />;
};

export default withValidUserRole(RightToWorkChecksPageContainer);
